// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"0c6f603e","787":"98fb7e2d"}[chunkId] + ".chunk.js";
};